import Phaser from 'phaser';

export function queueStageLoad(scene: Phaser.Scene) {
  scene.load.image('level-sky', 'Booga Town/SkyBackground.png');
  scene.load.image('level-world', 'Booga Town/Background.png');
  scene.load.image('level-clouds', 'Booga Town/Clouds.png');
}
